import React, { FC } from 'react';
import { IConfig } from '../../types/config';
import { IArticle } from '../../types/article';

import { IArticleBox1 } from './ArticleBox_1/params';
import { IArticleBox2 } from './ArticleBox_2/params';
import { IArticleBox3 } from './ArticleBox_3/params';
import { IArticleBox4 } from './ArticleBox_4/params';
import { IArticleBox5 } from './ArticleBox_5/params';
import { IArticleBox6 } from './ArticleBox_6/params';

import ArticleBox1 from './ArticleBox_1';
import ArticleBox2 from './ArticleBox_2';
import ArticleBox3 from './ArticleBox_3';
import ArticleBox4 from './ArticleBox_4';
import ArticleBox5 from './ArticleBox_5';
import ArticleBox6 from './ArticleBox_6';

const ArticleBox: FC<{
  config: IConfig;
  article: IArticle;
  withCategory?: boolean;
  activeCategory?: string;
  language: string;
}> = ({ config, article, withCategory, activeCategory, language }) => {
  switch (config.general.articleBox.variant) {
    case 6:
    case '6':
      return (
        <ArticleBox6
          language={language}
          config={config.general.articleBox.params as IArticleBox6}
          article={article}
          withCategory={withCategory}
          activeCategory={activeCategory}
        />
      );
    case 5:
    case '5':
      return (
        <ArticleBox5
          language={language}
          config={config.general.articleBox.params as IArticleBox5}
          article={article}
          withCategory={withCategory}
          activeCategory={activeCategory}
        />
      );
    case 4:
    case '4':
      return (
        <ArticleBox4
          language={language}
          config={config.general.articleBox.params as IArticleBox4}
          article={article}
          withCategory={withCategory}
          activeCategory={activeCategory}
        />
      );
    case 3:
    case '3':
      return (
        <ArticleBox3
          language={language}
          config={config.general.articleBox.params as IArticleBox3}
          article={article}
          withCategory={withCategory}
          activeCategory={activeCategory}
        />
      );
    case 2:
    case '2':
      return (
        <ArticleBox2
          language={language}
          config={config.general.articleBox.params as IArticleBox2}
          article={article}
          withCategory={withCategory}
          activeCategory={activeCategory}
        />
      );
    default:
      return (
        <ArticleBox1
          language={language}
          config={config.general.articleBox.params as IArticleBox1}
          article={article}
          withCategory={withCategory}
          activeCategory={activeCategory}
        />
      );
  }
};

export default ArticleBox;
